import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const SamplesIncentive = ({ incentive }) => {
    const { tablet } = useMediaQueryContext();
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83D\uDECD\uFE0F", label: "Place your first samples order", isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Order samples' : 'Order',
            to: routing.settings.samples.order,
        } }));
};
